<template>
  <b-modal :id="'modalTrackTalks'+id" centered hide-backdrop hide-footer>
    <template v-slot:modal-header-close>
      <i class="fa fa-close"></i>
    </template>

    <div class="calendario-secondary modal-track-talks">
      <div class="calendario-container">
        <div class="calendario-eventos-container">
          <div class="calendario-track">
              <div class="calendario-track-titulo">
                <h4 class="flex-fill"><span v-html='track.title'></span></h4>
              </div>
              <div class="calendario-track-eventos">
                <div class="evento" v-for="(talk,index) in availableTalks" :key="index">

                  <div class='event-card'>
                    <div class="event-time-container">
                      <div class="event-time">
                        <p>{{talk.date_start|formatTimeFromDate}}</p>
                        <p>às</p>
                        <p>{{talk.date_end|formatTimeFromDate}}</p>
                      </div>
                    </div>
                    <div class="event-info flex-fill">
                      <div class='event-card-title-container'>
                        <div class='event-card-title flex-fill'>
                          <h4>Palestra</h4>
                          <h5>{{talk.title}}</h5>
                        </div>
                        <div class='event-cta'>
                          <i class="far fa-calendar" @click.stop="addUserTalk(talk)" title="Adicionar evento na sua agenda" v-b-tooltip.hover v-if="!userHaveTalk(talk)"></i>
                          <i class="fas fa-minus-circle text-white" @click.stop="removeUserTalk(talk)" title="Remover evento da sua agenda" v-b-tooltip.hover v-else></i>
                        </div>
                      </div>
                      <div class='event-card-speakers'>
                        <div class='single-speaker-card' v-for="(speaker, index) in talk.speakers" :key="index">
                          <div class='speaker-avatar'><img :src='speaker.photo' class='avatar' width='20' height='20'></div>
                          <div class='speaker-info'>
                            <p class='speaker-name'>{{speaker.name}}</p>
                            <p class='speaker-cargo-empresa'>{{speaker.job_title}} - {{speaker.company}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
          </div>
        </div>
      </div>
    </div>


  </b-modal>
</template>
<script>
  import _ from 'lodash'

  export default {
    data() {
      return {
        id: 0,
        track: {},
        availableTalks: [],
        vm: this
      }
    },
    mounted: function() {
      this.id = this._uid;
    },
    methods: {
      openTalks(track, dia, talks) {

        var diaDate = this.$moment(dia).format('D');

        this.track = track;

        var vm = this;

        this.availableTalks = _.filter(talks, (item) => {

          var talkDate = vm.$moment(item.date_start).format('D');

          return item.trackSlug == track.id && diaDate == talkDate;

        });

        this.availableTalks = _.sortBy(this.availableTalks, (item) => { return item.date_start; });

        this.$bvModal.show('modalTrackTalks'+this.id);
      },
      addUserTalk(talk, index) {
        this.$addUserTalk(talk);

        console.log(index);

        this.$emit('update:selectTalk', talk);
      },
      tituloAdicionarEvento(talk) {
        return this.$userHaveTalk(talk)?"Evento já adicionado":"Adicionar evento à sua agenda";
      },
      userHaveTalk(talk) {
        return this.$userHaveTalk(talk);
      }

    },
    computed: {
      talksFiltradas() {
        return this.availableTalks.map(x => {
          return {...x, userHaveTalk: this.$userHaveTalk(x)}
        })
      }
    },
    filters: {
      dayOfDate: function (value) {
        if (!value) return '';
        var theDate = new Date(value);
        return theDate.getDate();
      },
      hourOfDate: function (value) {
        if (!value) return '';
        var theDate = new Date(value);
        return ('0'+theDate.getHours()).slice(-2)+":"+('0'+theDate.getMinutes()).slice(-2);
      },
      formatTimeFromDate: function(dtStr) {
        let d = new Date(dtStr);
        let hora = ("0" + d.getHours()).slice(-2) + "h" + ("0" + d.getMinutes()).slice(-2);
        return hora;
      }

    },

  }
</script>
<style lang="scss">
.modal-track-talks {
  margin: 0 !important;
  .calendario-container {
    .calendario-eventos-container {
      padding: 0 !important;
      .calendario-track {
        width: 100% !important;
        margin: 0 !important;
        box-shadow: unset  !important;

      }
    }
  }
}
</style>
